import { type InferType, array, object, string } from "yup";

export const placeSchema = object({
  _id: string().required(),
  placeLabel: string().required(),
  postalCodes: array(string().required()),
  postalCodesString: string(),
  placeKind: string().required(),
  department: array(string().required()),
});

export type TPlaceResolver = InferType<typeof placeSchema>;
